import { practice } from "../../data/practice";
import { buildBreadcrumbList } from "./breadcrumbs";
import { buildMedicalBusiness, MedicalBusinessOptions } from "./practiceEntity";
import { buildWebSite } from "./websiteEntity";

export interface PageGraphOptions extends MedicalBusinessOptions {
  pathname: string;
  pageName?: string;
  pageDescription?: string;
}

export function buildPageGraph(options: PageGraphOptions) {
  const { pathname, pageName, pageDescription, ...medicalOptions } = options;
  const pageUrl = pathname === "/" ? `${practice.baseUrl}/` : `${practice.baseUrl}${pathname}`;
  const webPageId = `${pageUrl}#webpage`;

  const graph = [
    buildWebSite(),
    buildMedicalBusiness({ ...medicalOptions }),
    buildBreadcrumbList(pathname),
    {
      "@type": "WebPage",
      "@id": webPageId,
      url: pageUrl,
      name: pageName ?? practice.name,
      description: pageDescription ?? practice.description,
      isPartOf: { "@id": `${practice.baseUrl}/#website` },
      about: { "@id": `${practice.baseUrl}/#organization` },
      inLanguage: "de-DE",
    },
  ];

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
}

export function buildStandaloneGraph(data: Record<string, unknown> | Record<string, unknown>[]) {
  return {
    "@context": "https://schema.org",
    ...(Array.isArray(data) ? { "@graph": data } : data),
  };
}
